import { TReduxActions } from '../../../types/redux';
import { IConfig, TConfigAction } from '../../../types/config';

export const SET_CONFIG = 'digest/SET_CONFIG';
export const SET_SUBDOMAIN = 'digest/SET_SUBDOMAIN';

const initialState: IConfig = {
  frontContentUrl: '',
  backContentUrl: '',
  subdomain: 'www',
  abGroup: 100,
  isDomrfEnabled: false,
};

export const setConfig = (contentUrl: string): TConfigAction => {
  return {
    type: SET_CONFIG,
    payload: {
      frontContentUrl: contentUrl,
      backContentUrl: contentUrl,
    },
  };
};

export const setSubdomain = (subdomain: string): TConfigAction => {
  return {
    type: SET_SUBDOMAIN,
    payload: { subdomain },
  };
};

export const configReducer = (state = initialState, action: TReduxActions) => {
  switch (action.type) {
    case SET_CONFIG:
      return Object.assign({}, state, {
        frontContentUrl: action.payload.frontContentUrl,
        backContentUrl: action.payload.backContentUrl,
      });

    case SET_SUBDOMAIN:
      return Object.assign({}, state, {
        subdomain: action.payload.subdomain,
      });

    default:
      return state;
  }
};
